export default "__VITE_PUBLIC_ASSET__a6224584__"